<template>
    <div @keydown="progressbar.userKeyDown()" @keyup="progressbar.userKeyUp()" @click="calculate_progress">
        <h3 
            class="
                mx-5 mt-5 mb-15
                md:mx-15 md:mt-15
                2xl:mx-20 2xl:mt-20 2xl:mb-20
            "
        >
            Activités extra-professionnelles
        </h3>

        <!-- BEGIN Button to add a "Activité" -->
        <add-button
            id="extrapro_add_activity"
            v-if="$can(infosPage.name_page+'_edit', infosPass.id_pass)"
            libelle="Ajouter une activité"
            @add="addActivity()"
            class="mx-5 md:mx-15 2xl:mx-20"
        />
        <!-- END Button to add a "Activité" -->

        <div v-if="form.activites.length > 0" >
            <list-grid 
                :list-items="form.activites"
                grid="grid-cols-11 md:grid-cols-12"
                :is-accordion-items="true"
                @displayNum="(num) => {activityDisplayed = num}"
                ref="listActivities"
            >
                <template #header>
                    <div class="col-start-2 md:col-start-2 col-span-5 md:col-span-2">Période</div>
                    <div class="hidden md:inline-block col-span-2">Type d'activité</div>
                    <div class="col-span-5 md:col-span-3">Activité</div>
                    <div class="hidden md:inline-block col-span-2">Environnement</div>
                    <div class="hidden md:inline-block col-span-2">Durée <span class="hidden lg:inline">hebdomadaire</span></div>
                </template>

                <!-- BEGIN Informations on accordion -->
                <template #accordionDescription="{item, num}">
                    <icon 
                        class="text-pink-600 col-span-1 justify-self-end md:justify-self-center
                            transform transition-transform ease-in-out duration-300"
                        :class="{'rotate-90': activityDisplayed == num}"
                        name="chevron-right"
                    />
                    <div class="col-span-5 md:col-span-2 text-base font-normal"> <!-- Période -->
                        <span v-if="item.debut">{{new Date(item.debut).getFullYear()}} - </span><span v-if="item.debut && !(item.fin)">en cours</span><span v-if="item.fin">{{new Date(item.fin).getFullYear()}}</span>
                    </div>
                    <div class="hidden md:inline-block col-span-2 text-base text-indigo-600 font-normal">
                        {{item.type}}
                    </div>
                    <div class="col-span-5 md:col-span-3 text-base text-pink-600 font-normal truncate">
                        {{item.activite}}
                    </div>
                    <div class="hidden md:inline-block col-span-2 text-base font-normal truncate">
                        {{item.environnement}}
                    </div>
                    <div class="hidden md:inline-block col-span-2 text-base font-normal" v-if="item.duree != undefined && item.duree != ''">
                        {{item.duree}} h
                    </div>
                        <div class="hidden md:inline-block col-span-2 text-base font-normal" v-else>
                    </div>
                </template>
                <!-- END Informations on accordion -->

                <template #accordionContent="{item, num}">
                    <!-- BEGIN list of activité -->
                    <div class="grid grid-cols-12 gap-x-4 gap-y-10">
                        <input-select 
                            class="md:col-span-4"
                            :necessary="true"
                            name="type"
                            libelle="Type d'activité"
                            :datas="[
                                {value: 'Culturelle'},
                                {value: 'Artistique'},
                                {value: 'Sportive'},
                                {value: 'Autre'},
                            ]"
                            :value="item.type" @input="(newValue) => {item.type = newValue}"
                        />

                        <transition
                            enter-active-class="ease-in duration-300"
                            enter-class="opacity-0"
                            leave-active-class="ease-out duration-300"
                            leave-to-class="opacity-0"
                        >
                            <input-text
                                v-if="item.type === 'Autre'"
                                :necessary="true"
                                :value="item.type_precision"
                                class="md:col-span-4"
                                libelle="Autre type d'activité"
                                name="type_precision"
                                @input="(newValue) => {item.type_precision = newValue}"
                            />
                        </transition>

                        <input-text
                            class="md:col-span-4"
                            :necessary="true"
                            name="activite"
                            libelle="Activité"
                            :value="item.activite" @input="(newValue) => {item.activite = newValue}"
                        />

                        <input-text
                            class="md:col-span-4"
                            :necessary="true"
                            name="duree"
                            libelle="Durée hebdomadaire (en h)"
                            :value="item.duree" @input="(newValue) => {item.duree = newValue}"
                        />

                        <input-text
                            class="md:col-span-4"
                            :necessary="true"
                            name="environnement"
                            libelle="Environnement (à titre personnel, au sein d'une structure...)"
                            :value="item.environnement" @input="(newValue) => {item.environnement = newValue}"
                        />

                        <div class="col-span-full md:col-span-8 grid grid-cols-2 gap-4">
                            <date-picker
                                name="debut"
                                class="col-span-full md:col-span-1"
                                :necessary-date="true"
                                libelle="Début"
                                format="yyyy"
                                min-view="year"
                                :value="item.debut" @input="(newValue) => {if (item.fin == '' || $verifyDates({debut: newValue, fin: item.fin})){item.debut = newValue} else {badDates()}; sortActivites();}"
                            />

                            <date-picker
                                name="fin"
                                class="col-span-full md:col-span-1"
                                :necessary-date="true"
                                libelle="Fin"
                                format="yyyy"
                                min-view="year"
                                :value="item.fin" @input="(newValue) => {if (item.debut == '' || $verifyDates({debut: item.debut, fin: newValue})){item.fin = newValue} else {item.fin = ''; badDates()};}"
                            />
                        </div>

                        <input-text-area
                            name="raisons"
                            :necessary="true"
                            libelle="Principales activités exercées"
                            size="5"
                            :value="item.raisons" @input="(newValue) => {item.raisons = newValue}"
                            class="md:col-span-6 lg:col-start-1"
                        />

                        <input-text-area
                            name="appris"
                            :necessary="true"
                            libelle="Principales réalisations que je souhaite mettre en valeur"
                            size="5"
                            :value="item.appris" @input="(newValue) => {item.appris = newValue}"
                            class="md:col-span-6"
                        />

                        <input-text-area
                            name="competences"
                            :necessary="true"
                            libelle="Compétences acquises"
                            size="5"
                            :value="item.competences" @input="(newValue) => {item.competences = newValue}"
                            class="md:col-span-6"
                        />

                        <input-text-area
                            name="remarques"
                            libelle="Commentaires"
                            size="5"
                            :value="item.remarques" @input="(newValue) => {item.remarques = newValue}"
                            class="md:col-span-6"
                        />

                        <!-- BEGIN button to delete an activity -->
                        <delete-button 
                            libelle="Supprimer cette activité"
                            @del="deleteItem(form.activites, num)"
                        />
                        <!-- END button to delete an activity -->
                    </div>
                    <!-- END list of activité -->
                </template>
            </list-grid>
        </div>
        <!-- END Activités extra professionnelles -->
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxGreen from '../../../components/Inputs/CheckboxGreen';
import CheckboxForm from '../../../components/Inputs/CheckboxForm';
import AddButton from '../../../components/Inputs/AddButton.vue';
import DeleteButton from '../../../components/Inputs/DeleteButton.vue';

import Icon from '../../../components/Icon';
import VerifyDates from '../../../mixins/VerifyDates';
import ListGrid from './../../../components/AccordionTable/ListGrid.vue';

export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon,
    AddButton,
    ListGrid,
    DeleteButton,
  },

  name: 'Activitesextraprofessionnelles',
    
  props:['progressbar'],
    
  mixins: [VerifyDates],

  data() {
    return {
      // Initial state of the form
      form:{
        activites: [],
      },
      activityDisplayed: -1,
    };
  },

  async mounted(){
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)

    await this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },

  methods: {
    ...mapMutations({
      SET_LOADING: 'app/SET_LOADING',
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
    }),

    initForm(){
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);

      this.sortActivites(false);
    },

    async addActivity(){
      await this.form.activites.unshift({
        debut: '',
        fin: '',
        activite: '',
        type: '',
        environnement: '',
        duree: '',
        type_precision:'',
      });

      await this.$refs.listActivities.displayNum(0, true);
    },

    deleteItem(el, index){
      el.splice(index, 1);
      this.$refs.listActivities.displayNum(-1);
    },

    sortActivites(sorting = true){
      let activiteDisplayed = this.form.activites[this.activityDisplayed];

      this.form.activites.sort(function(a1, a2){
        let date1 = new Date(a1.debut);
        let date2 = new Date(a2.debut);

        if(date1 < date2){
          return 1;
        }
        else if(date1 > date2){
          return -1;
        }
        else{
          return 0;
        }
      });
      if(sorting){
        this.$refs.listSituations.displayNum(this.form.activites.indexOf(activiteDisplayed), true);
      }
    }
  },

  computed:{
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
    }),
  },

  watch:{
    form: {
      handler(){
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    }
  },
};
</script>
